import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['image', 'accordionWrapper'];

  connect() {
    this.currentIndex = 0;
    this.startAutoPlay();
  }

  disconnect() {
    this.stopAutoPlay();
    if (this.restartTimeout) {
      clearTimeout(this.restartTimeout);
    }
  }

  startAutoPlay() {
    // Limpa qualquer interval existente antes de criar um novo
    this.stopAutoPlay();

    this.autoPlayInterval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.imageTargets.length;
      this.updateToIndex(this.currentIndex);
    }, 3000);
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }

  changeImage(event) {
    // Para o autoplay quando o usuário clicar manualmente
    this.stopAutoPlay();

    // Cancela o timeout anterior se existir
    if (this.restartTimeout) {
      clearTimeout(this.restartTimeout);
    }

    // Busca o elemento wrapper que contém o índice
    const wrapper = event.currentTarget;
    const imageIndex = parseInt(wrapper.dataset.imageIndex);

    this.currentIndex = imageIndex;
    this.updateToIndex(imageIndex);

    // Reinicia o autoplay após 5 segundos de inatividade
    this.restartTimeout = setTimeout(() => {
      this.startAutoPlay();
    }, 5000);
  }

  updateToIndex(imageIndex) {
    // Fecha todos os accordions
    this.accordionWrapperTargets.forEach((accordionWrapper, index) => {
      const accordionElement = accordionWrapper.querySelector(
        "[data-controller*='v3--accordion-card--controller']",
      );
      if (accordionElement) {
        const accordionController = this.application.getControllerForElementAndIdentifier(
          accordionElement,
          'v3--accordion-card--controller',
        );

        if (accordionController) {
          if (index === imageIndex) {
            // Abre o accordion clicado
            accordionController.open();
          } else {
            // Fecha os outros
            accordionController.close();
          }
        }
      }
    });

    // Altera a visibilidade das imagens
    this.imageTargets.forEach((image, index) => {
      if (index === imageIndex) {
        image.classList.remove('tw-opacity-0');
        image.classList.add('tw-opacity-100');
      } else {
        image.classList.remove('tw-opacity-100');
        image.classList.add('tw-opacity-0');
      }
    });
  }
}
